module.exports = "<div class=\"icon d-inline\">\n    <i class=\"fas fa-spinner fa-spin\"></i>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/ajax-loader/ajax-loader.component.html
// module id = ./src/app/components/tools/ajax-loader/ajax-loader.component.html
// module chunks = main